<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Add College Subscriptions">
      <div class="row">
        <div class="col-md-6 form-group">
          College Name
          <b-form-select v-model="collegeName" :options="options"></b-form-select>
        </div>
        <div class="col-md-6 form-group">
          Subscription
          <b-form-select v-model="subscription" :options="subscriptionOptions"></b-form-select>
        </div>
        <div class="col-md-6 form-group">
          Subscription Start Date
          <b-form-datepicker></b-form-datepicker>
        </div>
        <div class="col-md-6 form-group">
          Validity (days)
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-6 form-group">
          Price
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-6 form-group">
          Discount
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-6 form-group">
          Subscription Type
          <input class="form-control" type="text" value="College User" readonly/>
        </div>
        <div class="col-md-6 form-group">
           Status
          <b-form-select v-model="status" :options="statusoptions"></b-form-select>
        </div>
      </div>
      <div class="text-center">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          href="/#/backend/forms/add-subscription-videos"
          >Next</b-button
        >
      </div>
    </base-block>
     <br />
  </div>
</template>

<script>
export default {
  data() {
    return {
      collegeName: "",
      options: [{ text: "Panimalar College" }, { text: "Saveetha University" }, { text: "Sathyabama University"}, { text: "Anna University"}],
      subscription: "",
      subscriptionOptions: [ { text: "Company Papers" }, { text: "Competitive Exams" }, { text: "TCS Prime Course" } ],
      statusoptions: [ { text: "Active" }, { text: "Deactive" } ]
    };
  },
};
</script>

